export class Step4 {
    constructor() {}

    // intitule = 'stepper.form.dive_re.step3';
    section1 = 'form.dive_re.step4_section1';
    getnumlot = 'form.dive_re.getnumlot';
    getdescription = 'form.dive_re.getdescription';
    getquantite = 'form.dive_re.getquantite';
    getdateexecution = 'form.dive_re.getdateexecution';
    getdatelivraison = 'form.dive_re.getdatelivraison';
    getmotclef = 'form.dive_re.getmotclef_liste_avi_';
    getspan4 = 'form.dive_re.getspan4';
    getunlot = 'form.dive_re.getunlot';
    getplusieurslot = 'form.dive_re.getplusieurslot';
    gettouslots = 'form.dive_re.gettouslots';
    add = 'boutons.add';
    remove = 'boutons.remove';

    // intitule = 'stepper.form.dive_in.step4';
    getmiseenconcurrence = 'form.dive_in.getmiseenconcurrence';
    getinfocomplementaires = 'form.dive_in.getinfocomplementaires';

    intitule = 'stepper.form.dive_an.step7';
    getinfosannulation = 'form.dive_an.getinfosannulation';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';

}
